<cc-box>
  <div content box>

    <form class="wrapper" [formGroup]="panelForm">
      <div class="column">
        <span class="header" translate>PLANS.PANEL.BILLING_PERIOD</span>
        <div class="content content-radio-buttons">

          <mat-radio-group
            class="billing-period-group"
            formControlName="billingPeriod">
            <mat-radio-button
              value="P1M"><span translate>PLANS.PANEL.MONTHLY</span>
            </mat-radio-button>
            <mat-radio-button
              value="P1Y">
              <span translate>PLANS.PANEL.ANNUALLY</span>
              <span class="save-up" translate>PLANS.PANEL.SAVE_UP_TO</span></mat-radio-button>
          </mat-radio-group>

        </div>
      </div>

      <div class="column">
        <div class="content how-many-users">
          <cc-input-label-error-wrapper
            labelKey="PLANS.PANEL.HOW_MANY_USERS"
            [form]="panelForm"
            controlName="numberOfUsers"
            inputType="number"
            minValue="3">
          </cc-input-label-error-wrapper>
          <div *ngIf="isUserLimitReached" class="user-limit-error" translate>PLANS.PANEL.MAX_USER_ERROR</div>
<!--          <div *ngIf="isNotEnoughUsers" class="user-limit-error" translate>PLANS.PANEL.MIN_USER_ERROR</div>-->
        </div>
      </div>
    </form>


  </div>
</cc-box>
